import { ConfigurationId } from '@types';
import { PpssService } from './ppss.service';
import { FundFilterService } from './fund-filter.service';
import { Logger } from '@utils/logger';
import { PPSSFundDataService } from '@products/services/ppss-fund-data.service';
import { SiteConfigService } from '@services/site-config.service';
import { CaveatService } from '@products/caveats/services/caveat.service';
import { LiteratureDataService } from '@literature/services/literature-data.service';
import { AppStateService } from '@services/app-state.service';
import { Injectable } from '@angular/core';
import { SegmentService } from '@services/segment.service';
import { DebugService } from '@services/debug.service';
import { FavoritesService } from '@products/services/favorites.service';
import { LiteratureGlobalConfigService } from '@literature/services/literature-global-config.service';
import { ProductDetailService } from '@products/product-detail-layout/product-detail.service';
import { ProfileService } from '@services';
import { RouteHistoryService } from '@services/route-history.service';

const logger = Logger.getLogger('PpssServiceFactory');

@Injectable({
  providedIn: 'root',
})
export class PpssServiceFactory {
  services = new Map<ConfigurationId, PpssService>();
  currentProductType: ConfigurationId;

  constructor(
    private fundDataService: PPSSFundDataService,
    private filterService: FundFilterService,
    private siteConfigService: SiteConfigService,
    private caveatService: CaveatService,
    private literatureDataService: LiteratureDataService,
    private appStateService: AppStateService,
    private segmentService: SegmentService,
    private debugService: DebugService,
    private favoritesService: FavoritesService,
    protected literatureConfigService: LiteratureGlobalConfigService,
    protected productDetailService: ProductDetailService,
    protected profileService: ProfileService,
    protected routeHistoryService: RouteHistoryService
  ) {}

  setCurrentProductType(productType: ConfigurationId) {
    logger.debug('setting productType', productType);
    this.currentProductType = productType;
  }

  getPpssService(): PpssService {
    if (!this.services.has(this.currentProductType)) {
      logger.debug(
        'creating new PpssService for  productType',
        this.currentProductType
      );
      this.services.set(
        this.currentProductType,
        new PpssService(
          this.currentProductType,
          this.fundDataService,
          this.filterService,
          this.siteConfigService,
          this.caveatService,
          this.literatureDataService,
          this.appStateService,
          this.segmentService,
          this.debugService,
          this.favoritesService,
          this.literatureConfigService,
          this.productDetailService,
          this.profileService,
          this.routeHistoryService
        )
      );
    }
    return this.services.get(this.currentProductType);
  }
}
